export const CORE_URLS: Record<string, string> = {
  TERMS_OF_SERVICE: 'https://www.showshappening.com/home/disclaimer',
  PRIVACY_POLICY: 'https://www.showshappening.com/home/privacy',
  TOUR: 'https://showsmanager.com/',
  SHOWS_HAPPENING: 'https://www.showshappening.com/',
};

export const CORE_EMAIL = 'hello@showshappening.com';
